import constants from "utils/constants";

import { getErrorMessage } from "api/defaults";
import {
    loadEnvironmentAppRegistrations,
    loadEnvironments,
} from "api/environments/environments-api";

import { AppThunk } from "store/store";

import {
    setErrorMessageInactiveEnvironment,
    setErrorMessageInactiveTenant,
    setErrorResponseMessage,
    setLoaderVisibility,
} from "store/common/initialization/initialization-actions";
import { updateEnvironmentFilters } from "store/filters/filters-actions";

import {
    setActiveEnvironmentById,
    setActiveEnvironmentTenantsMonikers,
    setAppRegistrations,
    setEnvironments,
} from "store/environments/environment-actions";
import { updateEnvironmentPingInfo } from "store/environments/tenants/tenant-ping/tenant-ping-actions";

export const fetchEnvironments =
    (environmentId?: string): AppThunk =>
    async (dispatch) => {
        dispatch(setLoaderVisibility(true));
        dispatch(setErrorResponseMessage(""));
        dispatch(setErrorMessageInactiveEnvironment(""));
        dispatch(setErrorMessageInactiveTenant(""));

        const [payload, status] = await loadEnvironments();

        if (payload && status === constants.statusCode.OK) {
            dispatch(setEnvironments(payload));
            dispatch(updateEnvironmentFilters(payload));
            dispatch(updateEnvironmentPingInfo(payload));

            if (environmentId) {
                dispatch(
                    setActiveEnvironmentById(decodeURIComponent(environmentId))
                );
                dispatch(setActiveEnvironmentTenantsMonikers());
            }
        } else {
            const errorMessage = getErrorMessage(String(payload), status);

            dispatch(setErrorResponseMessage(errorMessage));
        }

        dispatch(setLoaderVisibility(false));
    };

export const fetchDooapAppRegistrations =
    (envMoniker: string): AppThunk =>
    async (dispatch) => {
        dispatch(setLoaderVisibility(true));
        dispatch(setErrorResponseMessage(""));
        dispatch(setErrorMessageInactiveEnvironment(""));
        dispatch(setErrorMessageInactiveTenant(""));

        const [payload, status] =
            await loadEnvironmentAppRegistrations(envMoniker);

        if (payload && status === constants.statusCode.OK) {
            dispatch(setAppRegistrations([...payload]));
        } else {
            const errorMessage = getErrorMessage(String(payload), status);

            dispatch(setErrorResponseMessage(errorMessage));
        }
        dispatch(setLoaderVisibility(false));
    };

export const fetchDooapAppRegistrationsWithoutLoader =
    (envMoniker: string): AppThunk =>
    async (dispatch) => {
        dispatch(setErrorResponseMessage(""));
        dispatch(setErrorMessageInactiveEnvironment(""));
        dispatch(setErrorMessageInactiveTenant(""));

        const [payload, status] =
            await loadEnvironmentAppRegistrations(envMoniker);

        if (payload && status === constants.statusCode.OK) {
            dispatch(setAppRegistrations([...payload]));
        } else {
            const errorMessage = getErrorMessage(String(payload), status);

            dispatch(setErrorResponseMessage(errorMessage));
        }
    };
